import yousersjs from '@yola/yousersjs';

const sendPasswordResetTokens = (data) => yousersjs.requests.passwordResetTokens(data);

export default sendPasswordResetTokens;
